import React from "react";
import { Dialog } from "@headlessui/react";
import { Button } from "../catalyst/button";

type LogoutDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export default function LogoutDialog({ open, onClose, onConfirm }: LogoutDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      {/* Overlay */}
      <div className="fixed inset-0 bg-black/60 backdrop-blur-sm" aria-hidden="true" />

      {/* Dialog panel */}
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="w-full max-w-sm rounded-lg bg-[#111827] text-white p-6 shadow-lg border border-[#1f2937]">
          <Dialog.Title className="text-lg font-semibold mb-1">Are you sure you want to log out?</Dialog.Title>
          <Dialog.Description className="text-sm text-gray-400 mb-6">
            Please confirm if you wish to proceed with logging out.
          </Dialog.Description>

          <div className="flex justify-end gap-2">
           <Button
              color="darktheme"
              onClick={onClose}
              type="button"
              className="!cursor-pointer"
            >
              Cancel
            </Button>
            <button
              type="button"
              onClick={onConfirm}
              className="rounded-md px-4 py-2 text-sm font-medium bg-brand-600 bg-brand-600 text-white disabled:opacity-60 disabled:cursor-not-allowed"
            >
              Confirm, logout
            </button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}
